<template>
  <div class="fenxiao-order-detail">
    <!-- 页面头部 -->
    <div class="page-header">
      <h2 class="page-title">推广订单详情</h2>
    </div>

    <!-- 加载状态 -->
    <div v-if="loading" class="loading-container">
      <div class="loading-spinner">
        <i class="el-icon-loading"></i>
        <span>加载中...</span>
      </div>
    </div>

    <!-- 订单详情内容 -->
    <div v-else class="order-detail">
      <div class="order-detail-box">
        <!-- 订单状态头部 -->
        <div class="header">
          <div class="title">
            <span>订单明细</span>
          </div>
          <div class="status">
            <span v-if="orderData && orderData.is_refund == 1" class="status-text refund">已退款</span>
            <span v-else-if="orderData && orderData.is_settlement == 1" class="status-text settled">已结算</span>
            <span v-else class="status-text pending">待结算</span>
          </div>
        </div>

        <!-- 商品信息 -->
        <div class="detail-body">
          <div class="detail-body-box">
            <div class="goods-image">
              <img 
                :src="orderData && orderData.sku_image ? $util.img(orderData.sku_image) : require('@/assets/images/shop-defaultImg.png')" 
                alt="商品图片"
              />
            </div>
            <div class="order-info">
              <div class="goods-name">{{ orderData ? orderData.sku_name : '-' }}</div>
              <div class="goods-sub-section">
                <div class="price-section">
                  <span class="goods-price">
                    <span class="unit">￥</span>
                    <span>{{ orderData ? orderData.price : '0.00' }}</span>
                  </span>
                </div>
                <div class="quantity-section">
                  <span class="quantity">
                    <i class="el-icon-close"></i>
                    {{ orderData ? orderData.num : 0 }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 订单详细信息 -->
        <div class="detail-content">
          <div class="order-info-item">
            <span class="label">订单号：</span>
            <span class="value">{{ orderData ? orderData.order_no : '-' }}</span>
          </div>
          <div class="order-info-item">
            <span class="label">分佣层级：</span>
            <span class="value">{{ orderData ? orderData.commission_level : '-' }}</span>
          </div>
          <div class="order-info-item">
            <span class="label">分销佣金：</span>
            <span class="value commission">￥{{ orderData ? orderData.commission : '0.00' }}</span>
          </div>
        </div>

        <!-- 订单合计 -->
        <div class="detail-footer">
          <div class="total-info">
            <span>共{{ orderData ? orderData.num : 0 }}件商品</span>
          </div>
          <div class="total-amount">
            <span>合计：</span>
            <span class="amount">￥{{ orderData ? orderData.real_goods_money : '0.00' }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getFenxiaoOrderDetail } from '@/api/fenxiao/order'

export default {
  name: 'FenxiaoOrderDetail',
  data() {
    return {
      loading: false,
      orderData: null,
      orderId: null
    }
  },
  created() {
    this.orderId = this.$route.query.id
    if (this.orderId) {
      this.getOrderData()
    }
  },
  methods: {
    async getOrderData() {
      this.loading = true
      try {
        const response = await getFenxiaoOrderDetail({
          fenxiao_order_id: this.orderId
        })
        
        if (response.code === 0) {
          this.orderData = response.data
        } else {
          this.$message.error(response.message || '获取订单详情失败')
        }
      } catch (error) {
        console.error('获取订单详情失败:', error)
        this.$message.error('获取订单详情失败')
      } finally {
        this.loading = false
      }
    },

    // 格式化时间
    formatTime(time) {
      if (!time) return '-'
      return new Date(time * 1000).toLocaleString()
    },

    // 获取订单状态文本
    getStatusText(status) {
      const statusMap = {
        1: '待结算',
        2: '已结算',
        3: '已退款'
      }
      return statusMap[status] || '未知状态'
    },

    // 获取订单状态样式
    getStatusClass(status) {
      const classMap = {
        1: 'status-pending',
        2: 'status-settled',
        3: 'status-refunded'
      }
      return classMap[status] || ''
    },

    // 返回上一页
    goBack() {
      this.$router.go(-1)
    },


  }
}
</script>

<style lang="scss" scoped>
.fenxiao-order-detail {
  padding: 20px;
  background-color: #f5f5f5;
  min-height: calc(100vh - 60px);

  .page-header {
    margin-bottom: 20px;
    
    .page-title {
      font-size: 24px;
      font-weight: 600;
      color: #333;
      margin: 0;
    }
  }

  .loading-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 200px;
    
    .loading-spinner {
      display: flex;
      align-items: center;
      font-size: 16px;
      color: #666;
      
      i {
        margin-right: 8px;
        font-size: 18px;
      }
    }
  }

  .order-detail {
    .order-detail-box {
      background: #ffffff;
      border-radius: 8px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      overflow: hidden;

      .header {
        padding: 20px;
        border-bottom: 1px solid #f0f0f0;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .title {
          position: relative;
          padding-left: 12px;
          font-size: 18px;
          font-weight: 600;
          color: #333;

          &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 4px;
            height: 18px;
            background: #409eff;
            border-radius: 2px;
          }
        }

        .status {
          .status-text {
            padding: 4px 12px;
            border-radius: 4px;
            font-size: 14px;
            font-weight: 500;

            &.refund {
              background: #f56c6c;
              color: white;
            }

            &.settled {
              background: #67c23a;
              color: white;
            }

            &.pending {
              background: #e6a23c;
              color: white;
            }
          }
        }
      }

      .detail-body {
        padding: 20px;
        border-bottom: 1px solid #f0f0f0;

        .detail-body-box {
          display: flex;
          align-items: flex-start;

          .goods-image {
            width: 120px;
            height: 120px;
            border-radius: 8px;
            overflow: hidden;
            border: 1px solid #f0f0f0;

            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }

          .order-info {
            flex: 1;
            margin-left: 16px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            height: 120px;

            .goods-name {
              font-size: 16px;
              color: #333;
              line-height: 1.5;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;
              margin-bottom: 10px;
            }

            .goods-sub-section {
              display: flex;
              justify-content: space-between;
              align-items: center;

              .price-section {
                .goods-price {
                  font-size: 18px;
                  font-weight: 600;
                  color: #e6a23c;

                  .unit {
                    font-size: 14px;
                    font-weight: normal;
                  }
                }
              }

              .quantity-section {
                .quantity {
                  font-size: 14px;
                  color: #666;

                  i {
                    margin-right: 4px;
                    font-size: 12px;
                  }
                }
              }
            }
          }
        }
      }

      .detail-content {
        padding: 20px;
        border-bottom: 1px solid #f0f0f0;

        .order-info-item {
          display: flex;
          margin-bottom: 12px;
          font-size: 14px;

          &:last-child {
            margin-bottom: 0;
          }

          .label {
            width: 120px;
            color: #666;
          }

          .value {
            flex: 1;
            color: #333;

            &.commission {
              color: #e6a23c;
              font-weight: 600;
            }
          }
        }
      }

      .detail-footer {
        padding: 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: #fafafa;

        .total-info {
          font-size: 14px;
          color: #666;
        }

        .total-amount {
          font-size: 16px;
          color: #333;

          .amount {
            color: #e6a23c;
            font-weight: 600;
            font-size: 18px;
          }
        }
      }
    }
  }
}
</style>